import { ArtistSupportSection } from "./sections/ArtistSupportSection";
import { ImportedMusicSection } from "./sections/ImportedMusicSection";
import { MusicRecommendationsSection } from "./sections/MusicRecommendationsSection";
import { UpcomingConcertsSection } from "./sections/UpcomingConcertsSection";
import { InboxSectionCta } from "./shared";
import type { InboxSection, OnNavigate, OnPlayTrack } from "./types";

/** Dispatches a content section to its matching native renderer. */
export const SectionRenderer = ({
  section,
  onNavigate,
  onPlayTrack,
}: {
  section: InboxSection;
  onNavigate: OnNavigate;
  onPlayTrack?: OnPlayTrack;
}) => {
  switch (section.item) {
    case "artist_support":
      return <ArtistSupportSection onNavigate={onNavigate} section={section} />;
    case "imported_music":
      return (
        <ImportedMusicSection
          onNavigate={onNavigate}
          onPlayTrack={onPlayTrack}
          section={section}
        />
      );
    case "upcoming_concerts":
      return (
        <UpcomingConcertsSection onNavigate={onNavigate} section={section} />
      );
    case "music_recommendations":
      return (
        <MusicRecommendationsSection
          onPlayTrack={onPlayTrack}
          section={section}
        />
      );
    case "fallback_link":
      return section.ctaUrl ? (
        <InboxSectionCta
          label={section.ctaText}
          onPress={() => onNavigate(section.ctaUrl)}
        />
      ) : null;
    default:
      // Unknown/newer section type the installed app build can't render yet.
      return null;
  }
};
